import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import { UseFormReturn } from 'react-hook-form'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setAdmissãoPadraoAGSUSPrazoDeterminado(params: Params): CustomFormQuestion[] {
  const { formMethods, questions } = params

  const { watch } = formMethods

  const visibleDependent2 = false
  const visibleDependent3 = false
  const visibleDependent4 = false
  const visibleDependent5 = false
  const visibleDependent6 = false

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const possuiCTPSDigital = watch(`form_answers.${titleForQuestion['CTPS digital?']}`)

  const deficienciaFisica = watch(`form_answers.${titleForQuestion['Deficiência física']}`)

  const possuiContaCorrenteOuContaSalarioNoBancoDoBrasil = watch(
    `form_answers.${titleForQuestion['Possui conta corrente ou conta salário no Banco do Brasil?']}`
  )

  const possuiDependente = watch(`form_answers.${titleForQuestion['Possui dependente?']}`)

  const declaraDependente1NoIRPF = watch(
    `form_answers.${titleForQuestion['Dependente 1 - Declara o dependente no IRPF']}`
  )

  const declaraDependente2NoIRPF = watch(
    `form_answers.${titleForQuestion['Dependente 2 - Declara o dependente no IRPF']}`
  )

  const declaraDependente3NoIRPF = watch(
    `form_answers.${titleForQuestion['Dependente 3 - Declara o dependente no IRPF']}`
  )

  const declaraDependente4NoIRPF = watch(
    `form_answers.${titleForQuestion['Dependente 4 - Declara o dependente no IRPF']}`
  )

  const declaraDependente5NoIRPF = watch(
    `form_answers.${titleForQuestion['Dependente 5 - Declara o dependente no IRPF']}`
  )

  const declaraDependente6NoIRPF = watch(
    `form_answers.${titleForQuestion['Dependente 6 - Declara o dependente no IRPF']}`
  )

  const declaracaoNepotismo = watch(`form_answers.${titleForQuestion['Declaração de nepotismo']}`)

  const seuProcessoSeletivoSeraPorProcessoSeletivoSimplificadoOuPorIndicacao = watch(
    `form_answers.${titleForQuestion['Seu processo seletivo será por processo seletivo simplificado ou por indicação?']}`
  )

  const eMenorde18anos = watch ? watch(`form_answers.${titleForQuestion['É menor de 18 anos?']}`) : undefined

  const filteredQuestions = questions.filter((question) => {
    const questionAboutDependent = question.title?.includes('Dependente')
    const match = question.title?.match(/Dependente (\d+) -/)
    let number = null

    // As lógicas para, caso necessário, remover questão não renderizadas na tela.

    if (questionAboutDependent) {
      if (match) {
        number = parseInt(match[1], 10)
      }
    }

    if (number == 1 && possuiDependente != 'Sim') {
      return false
    }

    //DEPENDENTE 1
    if (number == 1) {
      if (question.title == 'Dependente 1 - Comprovante do CPF' && declaraDependente1NoIRPF != 'Sim') {
        return false
      }
      if (question.title == 'Dependente 1 - Comprovante de vínculo' && declaraDependente1NoIRPF != 'Sim') {
        return false
      }
    }

    //DEPENDENTE 2
    if (number == 2 && !visibleDependent2) {
      return false
    }

    if (number == 2) {
      if (question.title == 'Dependente 2 - Comprovante do CPF' && declaraDependente2NoIRPF != 'Sim') {
        return false
      }
      if (question.title == 'Dependente 2 - Comprovante de vínculo' && declaraDependente2NoIRPF != 'Sim') {
        return false
      }
    }

    //DEPENDENTE 3
    if (number == 3 && !visibleDependent3) {
      return false
    }

    if (number == 3) {
      if (question.title == 'Dependente 3 - Comprovante do CPF' && declaraDependente3NoIRPF != 'Sim') {
        return false
      }
      if (question.title == 'Dependente 3 - Comprovante de vínculo' && declaraDependente3NoIRPF != 'Sim') {
        return false
      }
    }

    //DEPENDENTE 4
    if (number == 4 && !visibleDependent4) {
      return false
    }

    if (number == 4) {
      if (question.title == 'Dependente 4 - Comprovante do CPF' && declaraDependente4NoIRPF != 'Sim') {
        return false
      }
      if (question.title == 'Dependente 4 - Comprovante de vínculo' && declaraDependente4NoIRPF != 'Sim') {
        return false
      }
    }

    //DEPENDENTE 5
    if (number == 5 && !visibleDependent5) {
      return false
    }
    if (number == 5) {
      if (question.title == 'Dependente 5 - Comprovante do CPF' && declaraDependente5NoIRPF != 'Sim') {
        return false
      }
      if (question.title == 'Dependente 5 - Comprovante de vínculo' && declaraDependente5NoIRPF != 'Sim') {
        return false
      }
    }

    //DEPENDENTE 6
    if (number == 6 && !visibleDependent6) {
      return false
    }
    if (number == 6) {
      if (question.title == 'Dependente 6 - Comprovante do CPF' && declaraDependente6NoIRPF != 'Sim') {
        return false
      }
      if (question.title == 'Dependente 6 - Comprovante de vínculo' && declaraDependente6NoIRPF != 'Sim') {
        return false
      }
    }

    //CTPS
    if (
      question.title == 'CTPS - Número' ||
      question.title == 'CTPS - UF' ||
      question.title == 'CTPS - Data de emissão' ||
      question.title == 'CTPS - Série' ||
      question.title == 'CTPS - Comprovante'
    ) {
      if (possuiCTPSDigital == 'Não') {
        return true
      } else {
        return false
      }
    }

    //DEFICIÊNCIA FÍSICA
    if (question.title == 'Deficiência física - Laudo PCD') {
      if (deficienciaFisica != 'Sim') {
        return false
      }
    }

    //AGÊNCIA - DÍGITO - CONTA
    if (
      question.title == 'Agência' ||
      question.title == 'Dígito da agência' ||
      question.title == 'Conta' ||
      question.title == 'Dígito da conta' ||
      question.title == 'Comprovante de dados bancários: Conta corrente ou Conta salário'
    ) {
      if (
        possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Conta Corrente' ||
        possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Conta Salário'
      ) {
        return true
      } else {
        return false
      }
    }

    //Agência providencie a abertura de uma conta salário para você?
    if (question.title == 'Gostaria que a Agência providencie a abertura de uma conta salário para você?') {
      if (possuiContaCorrenteOuContaSalarioNoBancoDoBrasil == 'Não') {
        return true
      } else {
        return false
      }
    }

    //Possui chave PIX vinculada ao CPF?
    if (question.title == 'Possui chave PIX vinculada ao CPF?') {
      return true
    }

    //Possui chave PIX vinculada ao CPF?
    if (question.title == 'Possui chave PIX vinculada ao CPF?') {
      return true
    }

    //Nepotismo - identificação da pessoa
    if (question.title == 'Nepotismo - Identificação da pessoa') {
      if (
        declaracaoNepotismo ==
        'POSSUIR cônjuge, companheiro ou parente em linha reta, colateral ou por afinidade, até o terceiro grau, inclusive, com servidor(a) investido(a) em cargo de direção, chefia ou de assessoramento, abaixo relacionado, no âmbito do AgSUS, em qualquer esfera'
      ) {
        return true
      } else {
        return false
      }
    }

    //INDICAÇÃO
    if (
      question.title == 'Indicação - Nome da pessoa que indicou' ||
      question.title == 'Indicação - Cargo da pessoa que fez sua indicação' ||
      question.title == 'Indicação - Oficio da pessoa que fez sua indicação'
    ) {
      if (seuProcessoSeletivoSeraPorProcessoSeletivoSimplificadoOuPorIndicacao == 'Indicação') {
        return true
      } else {
        return false
      }
    }

    //MENOR DE 18 ANOS
    if (
      question.title == 'CPF do Responsável' ||
      question.title == 'RG do Responsável' ||
      question.title == 'Comprovante de documento RG ou CPF do Responsável' ||
      question.title == 'Grau de Parentesco do Responsável' ||
      question.title == 'Telefone do Responsável'
    ) {
      if (eMenorde18anos == 'Sim') {
        return true
      } else {
        return false
      }
    }

    return true
  }) // Final do filter

  return filteredQuestions
}
